/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./css/terms-of-service.css";
import { Segment, Form, Header } from "semantic-ui-react";
// import Images from '../media/privacy/privacy';

class ViewPrivacy extends Component {
  render() {
    return (
      <div className="mainContainer">
        <div className="flex-container">
          <div className="top-content">
            <Segment padded="very" className="login-form tos-form">
              <Form onSubmit={this.handleSubmit}>
                <Header as="h1">Privacy</Header>
                <Form.Field>
                  <div className="tosContainer">
                    <>
                      <h4
                        style={{
                          marginTop: "0in",
                          marginRight: "0in",
                          marginBottom: "7.5pt",
                          marginLeft: "0in",
                          fontSize: 16,
                          fontFamily: '"Calibri Light","sans-serif"',
                          color: "#2F5496",
                          fontWeight: "normal",
                          fontStyle: "italic",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 20,
                            fontFamily: '"Arial","sans-serif"',
                          }}
                        >
                          SCOPE OF THIS PRIVACY POLICY
                        </span>
                      </h4>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          KlearNow and its affiliates (“KlearNow,” “we,” “our,”
                          and/or “us”) value the privacy of individuals who use
                          our application, websites, and related services
                          (collectively, the “Platform”). This privacy policy
                          (the “Privacy Policy”) explains how we collect, use,
                          and share information from users (‘You” or “Users”) of
                          our Platform, who are comprised of individuals and
                          companies seeking customs brokerage services
                          (“Customers”), licensed customs brokers (“Brokers”)
                          and users of our Trucker application software
                          (“Truckers”).
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          This Privacy Policy applies to Users of KlearNow’s
                          Platform anywhere in the world. In this Privacy
                          Policy, we tell you what information we receive from
                          Customers, Brokers and Truckers, and how we use that
                          information to connect Customers, Brokers and Truckers
                          and to improve our services.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Beyond the Privacy Policy, your use of the Platform is
                          also subject to our Platform Terms and Conditions (
                        </span>
                        <a href="https://www.klearnow.ai/terms/">
                          <span
                            style={{
                              fontSize: 18,
                              fontFamily: '"Arial","sans-serif"',
                            }}
                          >
                            www.klearnow.ai/terms
                          </span>
                        </a>
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          ). Truckers using the Platform are subject to
                          additional Terms and Conditions for the Trucker
                          application software (“KlearDray”).
                        </span>
                      </p>
                      <h4
                        style={{
                          marginTop: "0in",
                          marginRight: "0in",
                          marginBottom: "22.5pt",
                          marginLeft: "0in",
                          fontSize: 16,
                          fontFamily: '"Calibri Light","sans-serif"',
                          color: "#2F5496",
                          fontWeight: "normal",
                          fontStyle: "italic",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 20,
                            fontFamily: '"Arial","sans-serif"',
                          }}
                        >
                          INFORMATION WE COLLECT
                        </span>
                      </h4>
                      <div
                        style={{
                          margin: "0in",
                          marginBottom: ".0001pt",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                        }}
                      >
                        <ol
                          start={1}
                          style={{
                            marginBottom: "0in",
                            listStyleType: "upper-alpha",
                            marginLeft: "0.5in",
                          }}
                        >
                          <li
                            style={{
                              margin: "0in",
                              marginBottom: ".0001pt",
                              fontSize: 16,
                              fontFamily: '"Calibri","sans-serif"',
                            }}
                          >
                            <h5
                              style={{
                                marginRight: "0in",
                                marginLeft: "0in",
                                fontSize: 13,
                                fontFamily: '"Times New Roman","serif"',
                                fontWeight: "bold",
                                background: "white",
                              }}
                            >
                              <span style={{ fontFamily: '"inherit","serif"' }}>
                                INFORMATION YOU PROVIDE TO US
                              </span>
                            </h5>
                          </li>
                        </ol>
                      </div>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Registration Information.
                        </span>
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          &nbsp;When you sign up for an account on the Platform,
                          you give us your name, email address, and phone
                          number.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          User Profile Information.
                        </span>
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          &nbsp;When you join the Platform, you can create an
                          Active Account by filling out a User profile.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          For Customers, this profile includes any information
                          you provide such as Customer’s legal entity type,
                          estimated business size (number of shipments, etc.),
                          shipping information such as default INCOTERMS; any
                          preferred freight forwarders, brokers, and carriers;
                          top origins; information relating to any bonds you or
                          your Broker holds in connection with the Services;
                          Customer’s Power of Attorney; Customer’s designation
                          of users authorized to access the Customer account and
                          their contact information; and Platform communication
                          preferences. Users can also add a User Payment Option
                          to authorized individuals with access to the Active
                          Account, which requires a designated business email
                          address and payment method.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          For Brokers, this profile includes any information you
                          provide such as Broker’s name; address; email address;
                          phone number; Broker ID or Filer Code, license number
                          and status; countries and jurisdictions for which
                          Broker is licensed to practice; experience; bonds held
                          by Broker; and preferences, including long term
                          customers, industries, availability for special
                          requests and off-hour Service requests, and
                          communication preferences. We also collect information
                          you provide concerning the working hours you elect for
                          providing your Services.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          For Truckers, no profile is created when downloading
                          and using the KlearDray App. However, once the
                          KlearDray App is downloaded, the Trucker’s contact
                          information and delivery transaction history is made
                          available to Customers using Trucker’s services on the
                          Platform and a TruckerScore is calculated for each
                          Trucker based on Customer feedback and Trucker’s
                          performance on completed delivery transactions.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Payment Method and Information.
                        </span>
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          &nbsp;When the User Payment Option is activated by a
                          Customer or Broker, Customers and Brokers can add an
                          electronic payment account, credit card and/or other
                          payment method to their active account, and a
                          third-party payment provider will receive and verify
                          your payment/credit card information. To keep your
                          financial data secure, we do not store full credit
                          card information on our servers. However, we keep
                          information about bank routing numbers, tax
                          information, and any other payment information
                          provided by Users that enable Users to make electronic
                          payments in connection with Services provided through
                          the Platform. Company reserves the right to change its
                          third-party payment provider at any time.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Communications.
                        </span>
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          &nbsp;If you contact us directly, we may receive
                          additional information about you. For example, when
                          you contact our Customer Support Team, we will receive
                          your name, email address, phone number, the contents
                          of a message or attachments that you may send to us,
                          and other information you choose to provide.
                        </span>
                      </p>
                      <div
                        style={{
                          margin: "0in",
                          marginBottom: ".0001pt",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                        }}
                      >
                        <ol
                          start={2}
                          style={{
                            marginBottom: "0in",
                            listStyleType: "upper-alpha",
                            marginLeft: "0.5in",
                          }}
                        >
                          <li
                            style={{
                              margin: "0in",
                              marginBottom: ".0001pt",
                              fontSize: 16,
                              fontFamily: '"Calibri","sans-serif"',
                            }}
                          >
                            <h5
                              style={{
                                marginRight: "0in",
                                marginLeft: "0in",
                                fontSize: 13,
                                fontFamily: '"Times New Roman","serif"',
                                fontWeight: "bold",
                                background: "white",
                              }}
                            >
                              <span style={{ fontFamily: '"inherit","serif"' }}>
                                INFORMATION WE COLLECT WHEN YOU USE THE PLATFORM
                              </span>
                            </h5>
                          </li>
                        </ol>
                      </div>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Device Information. When an Application is downloaded
                          by a User, the Company receives information from
                          User’s devices, including IP address, web browser
                          type, mobile operating system version, phone carrier
                          and manufacturer, application installations, device
                          identifiers, and push notification tokens.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Usage Information. To help us understand how You use
                          the Platform and to help Us improve it, we
                          automatically receive information about your
                          interactions with the Platform, like the pages or
                          other content you view, your actions within the
                          Platform apps, the dates and times of your visits and
                          the Services provided through the Platform.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Customer and Broker Transaction Information. KlearNow
                          collects the shipment information Customers provide in
                          connection with a request for Services as well as
                          information submitted by Brokers in connection with
                          the provision of Services. This information is saved
                          in the Platform’s database, including: data contained
                          in Customs forms and filings such as ISF data fields;
                          the package ID (Waybill manifest) or the good’s
                          container ID; the Declared Value for the goods; the
                          shipping company or carrier; information about the
                          good being shipped including cost and type, the HTS
                          Code, origination location, destination location; the
                          date of customs entry and release; the Carrier’s
                          payment status; the good’s Customs documentation and
                          documentation status; the Customer’s designated
                          recipient; and the revenues, calculated duties and
                          taxes and other fees for a particular Services
                          transaction.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Trucker Transaction Information. KlearNow also allows
                          Customers to track the delivery of their Shipments
                          from the port of entry to their intended destination
                          through the KlearDray App which tracks and collects
                          location, route and other trip information from a
                          Trucker using the KlearDray App. This trip information
                          may include, without limitation, Trucker’s name
                          together with the scheduled Shipment pick-up time and
                          date, the Shipment drop-off time and date, the pick-up
                          and drop-off address, trip route, distance travelled,
                          and duration. Information concerning Trucker’s
                          services history is also collected by the Platform and
                          shared with Trucker’s customers including: the Number
                          of Trucker jobs; the Number of deliverables; Number of
                          empty pickups; Percent delivered versus pickups; Total
                          number of hours served; Total number of miles served;
                          Number of delivery issues; Number of pickup issues;
                          Total number of issues; Percent of delivery/pickup
                          issues (“Trucker Dashboard Data”). In addition,
                          customers may provide feedback and rate Trucker’s
                          performance which is then incorporated into a
                          “TruckerScore.” Trucker’s own TruckerScore is visible
                          to Trucker on the KlearDray App and to Trucker’s
                          customers having an account on the Platform.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Call and Text Information/Communications Data. We work
                          with a third-party partner to facilitate phone calls
                          and text messages between Company and Users. We
                          receive information about these communications
                          including the date and time of the call or SMS
                          message, the parties’ phone numbers, and the content
                          of any SMS messages. For security purposes, we may
                          also monitor and/or record the contents of emails and
                          phone calls made on or through the Platform, such as
                          those between Customers and Brokers or Customers and
                          Truckers. You will be given notice that your call may
                          be recorded, and by proceeding you agree to allow
                          Company to monitor and/or record your call.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          User Feedback. At KlearNow, we want to make sure Users
                          are always satisfied the Services they provide or
                          receive. Customers may be given the opportunity from
                          time to time to rate and review Brokers at the
                          completion of services received. Customers may also
                          rate and review Truckers after a delivery transaction
                          is completed. We receive information about ratings and
                          reviews and give subsequent Customers information
                          about Brokers’ and Truckers’ ratings through an
                          internally calculated BrokerScore and TruckerScore.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Information from Cookies and Similar Technologies. We
                          collect information through the use of “cookies”,
                          tracking pixels, and similar technologies to
                          understand how you navigate through the Platform and
                          interact with KlearNow, to learn what functions and
                          features are popular, and to save your preferences.
                          Cookies are small text files that web servers place on
                          your device; they are designed to store basic
                          information and to help websites and apps recognize
                          your browser. We may use both session cookies and
                          persistent cookies. A session cookie disappears after
                          you close your browser. A persistent cookie remains
                          after you close your browser and may be accessed every
                          time you use the Platform. You should consult your web
                          browser(s) to modify your cookie settings. Please note
                          that if you delete or choose not to accept cookies
                          from us, you may be missing out on certain features of
                          the Platform.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Location Information. When the KlearDray App is
                          downloaded by a Trucker delivering goods from a port
                          of entry to a designated recipient, KlearNow tracks
                          the location of the Trucker and calculates the goods’
                          estimated time of arrival at its designated location.
                          To do this, a Trucker appointed by a Customer must
                          download the KlearDray App and must give us permission
                          through their device settings or the KlearDray App.
                          Trucker’s location information, route, duration, and
                          distance travelled is then tracked. We may also
                          collect and track the Trucker’s location while the app
                          is off.
                        </span>
                      </p>
                      <div
                        style={{
                          margin: "0in",
                          marginBottom: ".0001pt",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                        }}
                      >
                        <ol
                          start={3}
                          style={{
                            marginBottom: "0in",
                            listStyleType: "upper-alpha",
                            marginLeft: "0.5in",
                          }}
                        >
                          <li
                            style={{
                              margin: "0in",
                              marginBottom: ".0001pt",
                              fontSize: 16,
                              fontFamily: '"Calibri","sans-serif"',
                            }}
                          >
                            <h5
                              style={{
                                marginRight: "0in",
                                marginLeft: "0in",
                                fontSize: 13,
                                fontFamily: '"Times New Roman","serif"',
                                fontWeight: "bold",
                                background: "white",
                              }}
                            >
                              <span style={{ fontFamily: '"inherit","serif"' }}>
                                INFORMATION WE COLLECT FROM THIRD PARTIES
                              </span>
                            </h5>
                          </li>
                        </ol>
                      </div>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Third Party Services including Third Party Payment
                          Providers and Financial Services Providers. If you
                          choose to register for the Platform or otherwise link
                          your Platform account with a third party’s service
                          (such as using the User Payment Option), we may
                          receive the same type of information we collect from
                          you (described above) directly from those services.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Third Party Partners. We may receive additional
                          information about you, such as demographic data,
                          payment information, or fraud detection information,
                          from third party partners and combine it with other
                          information that we have about you.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Background Information on Brokers. KlearNow works to
                          perform licensing checks on Brokers using publicly
                          available information about a Broker’s current license
                          or permit status.
                        </span>
                      </p>
                      <h6
                        style={{
                          marginTop: "0in",
                          marginRight: "0in",
                          marginBottom: "15.0pt",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri Light","sans-serif"',
                          color: "#1F3763",
                          fontWeight: "normal",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"inherit","serif"',
                            color: "#003F5C",
                          }}
                        >
                          HOW WE USE THE INFORMATION WE COLLECT
                        </span>
                      </h6>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          We use the information we collect from all Users to:
                        </span>
                      </p>
                      <ul style={{ listStyleType: "disc" }}>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Connect Customers with Brokers;
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Provide, improve, expand, and promote the Platform;
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Analyze how the KlearNow community uses the
                            Platform;
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Communicate with you, either directly or through one
                            of our partners;
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Personalize the KlearNow experience for you;
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Send you text messages and push notifications;
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Facilitate transactions and payments;
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Provide you with customer support;
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Find and prevent fraud; and
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Respond to trust and safety issues that may arise,
                            including incidents or disputes between Customers
                            and Brokers, and requests from government
                            authorities.
                          </span>
                        </li>
                      </ul>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Additionally, we use the information we collect from
                          Users for the following purposes related to the
                          Platform:
                        </span>
                      </p>
                      <ul style={{ listStyleType: "disc" }}>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Sending emails and text messages to Users who have
                            started the user registration process regarding the
                            status of their registration;
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Determining a Broker’s eligibility to provide
                            Services through the Platform;
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Notifying Brokers about Customer demand, pricing and
                            service updates; and
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Calculating and analyzing usage patterns for
                            business purposes.
                          </span>
                        </li>
                      </ul>
                      <h6
                        style={{
                          marginTop: "0in",
                          marginRight: "0in",
                          marginBottom: "15.0pt",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri Light","sans-serif"',
                          color: "#1F3763",
                          fontWeight: "normal",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"inherit","serif"',
                            color: "#003F5C",
                          }}
                        >
                          HOW WE SHARE THE INFORMATION WE COLLECT
                        </span>
                      </h6>
                      <ul style={{ listStyleType: "disc" }}>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Sharing Between UsersSharing between Customers and
                            Brokers. Customers and Brokers that have been
                            matched for the provision and receipt of Services
                            are able to see basic information about each other,
                            such as Broker and Customer names, Broker’s license
                            number and BrokerScore, as well as information
                            relating to Customer’s shipment as needed to
                            complete the provision of Services such as
                            Customer’s Carrier, the intended Recipient of
                            Customer’s goods, information about Customer’s goods
                            including cost, type, HTS Code, Declared Value, Cost
                            of shipping, origin and destination location, and a
                            Job ID assigned by the Platform. We de-identify the
                            Broker ratings and feedback, but we can’t rule out
                            that a Broker may be able to identify the Customer
                            that provided the rating or feedback.Sharing between
                            Customers and Truckers. Truckers that have been
                            appointed by Customers to deliver Customer’s goods
                            from a port of entry to the designated recipient’s
                            location will receive Customer feedback on the
                            delivery transaction once completed. That feedback
                            will be used in part to calculate a TruckerScore
                            that will then be made available to other Customers
                            that use the Trucker’s delivery services.If you
                            participate in the User Payment Option, we will
                            provide the User’s account administrator with
                            information about your use of the Platform,
                            including transaction details such as date, time,
                            charge, duties and taxes.
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Sharing Between KlearNow and Third PartiesService
                            Providers. We work with third party service
                            providers to perform services on our behalf, and we
                            may share your information with such service
                            providers to help us provide the Platform, including
                            all of the things described in Section 5(b) of the
                            Platform Terms.Other Sharing. We may share your
                            information with third parties in the following
                            cases:
                          </span>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                While negotiating or in relation to a change of
                                corporate control such as a restructuring,
                                merger or sale of our assets;
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                If a government authority requests information
                                and we think disclosure is required or
                                appropriate in order to comply with laws,
                                regulations, or a legal process;
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                With law enforcement officials, government
                                authorities, or third parties if we think doing
                                so is necessary to protect the rights, property,
                                or safety of the KlearNow community, KlearNow,
                                or the public;
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                To comply with a legal requirement or process,
                                including but not limited to, civil and criminal
                                subpoenas, court orders or other compulsory
                                disclosures.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                With our insurance partners to help determine
                                and provide relevant coverage in the event of an
                                incident;
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                To provide information about the use of the
                                Platform to potential business partners in
                                aggregated or de-identified form that can’t
                                reasonably be used to identify you; and
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                Whenever you consent to the sharing.
                              </span>
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <h6
                        style={{
                          marginTop: "0in",
                          marginRight: "0in",
                          marginBottom: "15.0pt",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri Light","sans-serif"',
                          color: "#1F3763",
                          fontWeight: "normal",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"inherit","serif"',
                            color: "#003F5C",
                          }}
                        >
                          YOUR CHOICES
                        </span>
                      </h6>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Email Subscriptions. Users can opt out of promotional
                          emails, however, KlearNow will still send you
                          transactional and relational emails about your account
                          use of the Platform.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Text Messages. You can opt out of receiving commercial
                          or promotional text messages by texting the word STOP
                          to ____ from the mobile device receiving the messages.
                          You may also opt out of receiving all texts from
                          KlearNow (including transactional or relational
                          messages) by texting the word STOPALL to ____ from the
                          mobile device receiving the messages, however, opting
                          out of receiving texts may impact your use of the
                          Platform including automatic deactivation of the
                          KlearDray App. Truckers can also opt out of
                          driver-specific messages by texting STOP in response
                          to a driver SMS. To re-enable texts you can text START
                          in response to an unsubscribe confirmation SMS.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Push Notifications. You can opt out of receiving push
                          notifications through your device settings. Please
                          note that opting out of receiving push notifications
                          may impact your use of the Platform.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Profile Information. While your name will always be
                          shared with Users in connection with the provision and
                          receipt of services, you can delete or modify certain
                          additional information that you added to your Profile
                          at any time if you don’t want Users to see it.
                          Customers will always be able to see Brokers’ names,
                          BrokerScore, Broker license information and a
                          Trucker’s TruckerScore and delivery transaction
                          history.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Location Information. While Truckers delivering a
                          Shipment on behalf of a Customer can prevent their
                          goods from being tracked at any time through the
                          KlearDray App by turning off “location tracking” on
                          their device, Shipment tracking and location is core
                          to the KlearDray App and without it we cannot provide
                          map and/or GPS voice navigation services and other
                          information to you if your “location tracking” is
                          turned off on your device.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Editing and Accessing Your Information. You can review
                          and edit certain account information by logging in to
                          your account settings and profile. If would like to
                          terminate your account, please contact us through our
                          Help Center with your request. If you choose to
                          terminate your account, we will deactivate it for you
                          but may retain information from your account for a
                          certain period of time and disclose it in a manner
                          consistent with our practices under this Privacy
                          Policy for accounts that are not closed. We also may
                          retain information from your account to collect any
                          fees owed, resolve disputes, troubleshoot problems,
                          analyze usage of the Platform, assist with any
                          investigations, prevent fraud, enforce our Terms, or
                          take other actions as required or permitted by law.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          We process personal information submitted to the
                          Platform inside the United States and Canada.
                          Therefore, KlearNow transfers information of users in
                          the EEA outside the EEA on the basis of mechanisms
                          approved under applicable laws and regulations.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Questions, comments and complaints about KlearNow’s
                          data practices can be submitted to KlearNow’s data
                          protection office through the KlearNow.AI website or
                          by email to&nbsp;
                        </span>
                        <a href="mailto:Privacylegal@KlearNow.com">
                          <span
                            style={{
                              fontSize: 18,
                              fontFamily: '"Arial","sans-serif"',
                            }}
                          >
                            Privacylegal@KlearNow.com
                          </span>
                        </a>
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          .
                        </span>
                      </p>
                      <h6
                        style={{
                          marginTop: "0in",
                          marginRight: "0in",
                          marginBottom: "15.0pt",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri Light","sans-serif"',
                          color: "#1F3763",
                          fontWeight: "normal",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"inherit","serif"',
                            color: "#003F5C",
                          }}
                        >
                          OTHER
                        </span>
                      </h6>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Data Security. We are committed to protecting the data
                          of the KlearNow community. Even though we take
                          reasonable precautions to protect your data, no
                          security measures can be 100% secure, and we cannot
                          guarantee the security of your data.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Children’s Privacy. KlearNow is not directed to
                          children, and we don’t knowingly collect personal
                          information from children under 13. If we find out
                          that a child under 13 has given us personal
                          information, we will take steps to delete that
                          information. If you believe that a child under the age
                          of 13 has given us personal information, please
                          contact us at our Help Center.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Changes to Our Privacy Policy. We may make changes to
                          this Privacy Policy from time to time. If we make any
                          material changes, we will let you know through the
                          Platform, by email, or other communication. We
                          encourage you to read this Privacy Policy periodically
                          to stay up-to-date about our privacy practices. As
                          long as you use the Platform, you are agreeing to this
                          Privacy Policy and any updates we make to it.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Contact Information. Feel free to contact us at any
                          time with any questions or comments about this Privacy
                          Policy, your personal information, our use and sharing
                          practices, or your consent choices by contacting our
                          Help Center or by email to&nbsp;
                        </span>
                        <a href="mailto:Privacylegal@KlearNow.com">
                          <span
                            style={{
                              fontSize: 18,
                              fontFamily: '"Arial","sans-serif"',
                            }}
                          >
                            Privacylegal@KlearNow.com
                          </span>
                        </a>
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          .
                        </span>
                      </p>
                      <h6
                        style={{
                          marginTop: "0in",
                          marginRight: "0in",
                          marginBottom: "15.0pt",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri Light","sans-serif"',
                          color: "#1F3763",
                          fontWeight: "normal",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"inherit","serif"',
                            color: "#003F5C",
                          }}
                        >
                          INFORMATION RETENTION AND DELETION
                        </span>
                      </h6>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Times New Roman","serif"',
                          marginTop: "0in",
                          marginBottom: ".25in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          SUMMARY
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          KlearNow requires user profile information in order to
                          provide its services, and retains such information for
                          as long you maintain your KlearNow account. Once such
                          information is no longer necessary to provide
                          KlearNow’ services, enable customer support, enhance
                          the user experience or other operational purposes,
                          KlearNow takes steps to prevent access to or use of
                          such information for any purpose other than compliance
                          with these requirements or for purposes of safety,
                          security and fraud prevention and detection.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          KlearNow retains certain information, including
                          transaction, usage, device and other information as
                          legally required in connection with regulatory, tax,
                          insurance or other requirements in the places in which
                          it operates including applicable Customs regulations.
                          KlearNow thereafter deletes or anonymizes such
                          information in accordance with applicable laws.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Users may request deletion of their accounts at any
                          time through the Privacy Settings in the KlearNow
                          apps, or via KlearNow’ website Help page. Following
                          such request, KlearNow deletes the information that it
                          is not required to retain, and restricts access to or
                          use of any information it is required to retain.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          In certain circumstances, KlearNow may be unable to
                          delete your account, such as if there is an
                          outstanding credit on your account or an unresolved
                          claim or dispute. Upon resolution of the issue
                          preventing deletion, KlearNow will delete your account
                          as described above.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          KlearNow may also retain certain information if
                          necessary for its legitimate business interests, such
                          as fraud prevention and enhancing users’ safety and
                          security. For example, if KlearNow shuts down a user’s
                          account because of unsafe behavior or security
                          incidents, KlearNow may retain certain information
                          about that account to prevent that user from opening a
                          new KlearNow account in the future.
                        </span>
                      </p>
                      <h6
                        style={{
                          marginTop: "0in",
                          marginRight: "0in",
                          marginBottom: "15.0pt",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri Light","sans-serif"',
                          color: "#1F3763",
                          fontWeight: "normal",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"inherit","serif"',
                            color: "#003F5C",
                          }}
                        >
                          SPECIAL INFORMATION FOR EU USERS
                        </span>
                      </h6>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Times New Roman","serif"',
                          marginTop: "0in",
                          marginBottom: ".25in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          SUMMARY
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          Beginning May 25, 2018, the processing of personal
                          data of users in the European Union is subject to the
                          EU General Data Protection Regulation (“GDPR”). This
                          section summarizes KlearNow’ grounds for processing
                          personal information under the GDPR, and the rights of
                          EU users as relates to KlearNow’ handling of personal
                          information, and KlearNow’ responsibilities, under
                          this regulation.
                        </span>
                      </p>
                      <div
                        style={{
                          margin: "0in",
                          marginBottom: ".0001pt",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                        }}
                      >
                        <ul
                          style={{ marginBottom: "0in", listStyleType: "disc" }}
                        >
                          <li
                            style={{
                              margin: "0in",
                              marginBottom: ".0001pt",
                              fontSize: 16,
                              fontFamily: '"Calibri","sans-serif"',
                            }}
                          >
                            <h6
                              style={{
                                marginTop: "2.0pt",
                                marginRight: "0in",
                                marginBottom: ".0001pt",
                                marginLeft: "0in",
                                fontSize: 16,
                                fontFamily: '"Calibri Light","sans-serif"',
                                color: "#1F3763",
                                fontWeight: "normal",
                                background: "white",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: '"inherit","serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                EU USER RIGHTS
                              </span>
                            </h6>
                          </li>
                        </ul>
                      </div>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.75in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          If you are a KlearNow User in the EU, you have the
                          following rights with respect to KlearNow’ handling of
                          your personal information:
                        </span>
                      </p>
                      <ul style={{ listStyleType: "disc" }}>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Explanation and copies of your data
                          </span>
                          <ol style={{ listStyleType: "lower-roman" }}>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                You have the right to request an explanation of
                                the information that KlearNow has about you and
                                how KlearNow uses that information.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                You also have the right to receive a copy of the
                                information that KlearNow collects about you if
                                collected on the basis of consent or because
                                KlearNow requires the information to provide the
                                services that you request.
                              </span>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Correction. If KlearNow has information about you
                            that you believe is inaccurate, you have the right
                            to request correction of your information.
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Deletion
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Explanation and copies of your data
                          </span>
                          <ol style={{ listStyleType: "lower-roman" }}>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                Users may request deletion of their accounts at
                                any time via KlearNow’ website Help page. We may
                                retain certain information about you as required
                                by law including applicable Customs regulations
                                and for legitimate business purposes permitted
                                by law.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                Please see the “Information Retention &amp;
                                Deletion” section above for more information
                                regarding KlearNow’s retention and deletion
                                practices.
                              </span>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Objections and complaints
                          </span>
                          <ol style={{ listStyleType: "lower-roman" }}>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                Users in the EU have the right to object to
                                KlearNow’s processing of personal data,
                                including for marketing purposes based on
                                profiling and/or automated decision making.
                                KlearNow &nbsp;may continue to process your
                                information notwithstanding the objection to the
                                extent permitted under GDPR.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                Users in the EU also have the right to file a
                                complaint relating to KlearNow’s handling of
                                your personal information to the appropriate
                                Supervisory Authority in the EU. You may also
                                submit a complaint to KlearNow’ Data Protection
                                Office by email to&nbsp;
                              </span>
                              <a href="mailto:Privacylegal@KlearNow.com">
                                <span
                                  style={{
                                    fontFamily: '"Arial","sans-serif"',
                                    fontSize: 18,
                                  }}
                                >
                                  Privacylegal@KlearNow.com
                                </span>
                              </a>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  color: "#003F5C",
                                  fontSize: 18,
                                }}
                              >
                                .
                              </span>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            To exercise these rights, please submit your request
                            by contacting KlearNow through the KlearNow.AI
                            website Help page or by email to&nbsp;
                          </span>
                          <a href="mailto:Privacylegal@KlearNow.com">
                            <span
                              style={{
                                fontFamily: '"Arial","sans-serif"',
                                fontSize: 18,
                              }}
                            >
                              Privacylegal@KlearNow.com
                            </span>
                          </a>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              color: "#003F5C",
                              fontSize: 18,
                            }}
                          >
                            . Users outside the EU may also request explanation,
                            correction, deletion or copies of their personal
                            data through the KlearNow.AI website.You can also
                            edit the profile information associated with your
                            account through the Settings menu in KlearNow.AI
                            website and apps. You can also look up your
                            transaction history on the KlearNow.AI website and
                            apps
                          </span>
                        </li>
                      </ul>
                      <div
                        style={{
                          margin: "0in",
                          marginBottom: ".0001pt",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                        }}
                      >
                        <ul
                          style={{ marginBottom: "0in", listStyleType: "disc" }}
                        >
                          <li
                            style={{
                              margin: "0in",
                              marginBottom: ".0001pt",
                              fontSize: 16,
                              fontFamily: '"Calibri","sans-serif"',
                            }}
                          >
                            <h6
                              style={{
                                marginTop: "2.0pt",
                                marginRight: "0in",
                                marginBottom: ".0001pt",
                                marginLeft: "0in",
                                fontSize: 16,
                                fontFamily: '"Calibri Light","sans-serif"',
                                color: "#1F3763",
                                fontWeight: "normal",
                                background: "white",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: '"inherit","serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                GROUNDS FOR PROCESSING
                              </span>
                            </h6>
                          </li>
                        </ul>
                      </div>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.75in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          The GDPR requires that companies processing the
                          personal data of EU users do so on the basis of
                          specific legal grounds. As described below, KlearNow
                          processes the information of EU users based on one or
                          more of the grounds specified under the GDPR:
                        </span>
                      </p>
                      <ul style={{ listStyleType: "disc" }}>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            The processing is necessary to provide the services
                            and features you request. KlearNow must collect and
                            use certain information in order to provide its
                            services. This includes:
                          </span>
                          <ol style={{ listStyleType: "lower-roman" }}>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                User profile information that is necessary to
                                establish and maintain your account, including
                                to verify your identity; enable communications
                                with you about your Services and accounts; and
                                to enable you to make payments or receive
                                earnings.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                Broker Background Licensing Information which is
                                collected from publicly available sources is
                                necessary to enable Broker to provide Services
                                through the KlearNow Platform.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                Transaction information, which is necessary to
                                generate and maintain in connection with your
                                use of KlearNow’ Platform and provision or
                                receipt of services.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                Trucker Location Information, which is necessary
                                to determine the estimated arrival time of a
                                delivery and to track trips while in-progress
                                and suggest navigation.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                Usage information, which is necessary to
                                maintain, optimize and enhance KlearNow’
                                services and the Platform, including to
                                determine, sometimes in combination with other
                                information, the best match between Customers
                                and Brokers, and calculate costs of providing
                                Services and Broker Rates. Collection and use of
                                this information is a requirement for using the
                                KlearNow Platform.
                              </span>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            The processing is necessary to protect the vital
                            interests of our users or of others. KlearNow may
                            process personal information, including disclosing
                            data with law enforcement authorities in case of
                            threats to the safety of users or of others.
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            The processing is necessary for KlearNow’s
                            legitimate interests. KlearNow collects and uses
                            personal information to the extent necessary for its
                            legitimate interests. This includes collecting and
                            using information:
                          </span>
                          <ol style={{ listStyleType: "lower-roman" }}>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                To maintain and enhance our Users’ experience
                                with the Platform. For example, we collect
                                information on the Services you receive or
                                provide and Broker’s Updated License Information
                                using publicly available sources to facilitate
                                the provision of Services through our Platform.
                                We also use personal information to prevent use
                                of our services by users who have engaged in
                                inappropriate or dangerous behavior, such as by
                                retaining information of banned users to prevent
                                their use of KlearNow Platform. We also use
                                usage information to better match Customers and
                                Brokers.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                To prevent, detect and combat fraud in
                                connection with the use of our services. For
                                example, KlearNow uses User profile, location,
                                device and usage information, to identify and
                                prevent circumstances when users attempt to
                                defraud KlearNow or other users.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                To inform law enforcement officials regarding
                                criminal acts or threats to public safety.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                To provide customer support.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                To optimize our service and develop new
                                services. This includes, for example,
                                identifying the best matches between Customers
                                and Brokers, recommending (new) features,
                                improving navigation, and enhancing pricing.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                For research and analytical purposes. This
                                includes, for example, analyzing usage trends to
                                improve the user experience and enhance the
                                efficiency and security of our services.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                For direct marketing purposes. This includes,
                                for example, analyzing data to identify trends
                                and tailor features to user needs.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                To enforce KlearNow’s Terms and Conditions of
                                service including use of the Platform.
                              </span>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            The processing is necessary for the legitimate
                            interests of other persons or parties. KlearNow
                            collects and uses personal information to the extent
                            necessary for the interests of other persons or the
                            general public. This includes sharing information in
                            connection with legal or insurance claims, to
                            protect the rights and safety of others. KlearNow
                            may also process personal information when necessary
                            in regards to a substantial public interest, on the
                            basis of applicable laws.
                          </span>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            The processing is necessary to fulfill KlearNow’
                            legal obligations.
                          </span>
                          <ol style={{ listStyleType: "lower-roman" }}>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                KlearNow is subject to legal requirements in the
                                jurisdictions in which it operates that require
                                us to collect, process, disclose and retain your
                                personal data. For example, KlearNow is subject
                                to laws and regulations in many cities and
                                countries that require it to collect and retain
                                information about your Services, to retain such
                                information for extended periods of time, and to
                                provide copies of such information to
                                governmental or other authorities. KlearNow uses
                                your information to comply with such laws to the
                                extent they apply to your use of the KlearNow
                                Platform.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                KlearNow may also share information with law
                                enforcement, or requests by third parties
                                pursuant to legal processes.
                              </span>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <span
                            style={{
                              fontFamily: '"Arial","sans-serif"',
                              fontSize: "13.5pt",
                              color: "#003F5C",
                            }}
                          >
                            Consent
                          </span>
                          <ol style={{ listStyleType: "lower-roman" }}>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                KlearNow may collect and use your information on
                                the basis of your consent. You may revoke your
                                consent at any time. If you revoke your consent,
                                you will not be able to use any service or
                                feature that requires collection or use of the
                                information we collected or used on the basis of
                                consent.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                KlearNow relies on consent in connection with
                                data collections or uses that are necessary to
                                enable and enhance the User experience, to
                                enable optional services or features, or to
                                communicate with you.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                KlearNow may also collect personal information
                                about you through voluntary surveys. Your
                                responses to such surveys are collected on the
                                basis of consent, and will be deleted once no
                                longer necessary for the purposes collected.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                Device Permissions. Most mobile platforms (iOS,
                                Android, etc.) have defined certain types of
                                device data that apps cannot access without your
                                consent. And these platforms have different
                                permission systems for obtaining your consent.
                                The iOS platform will alert you the first time
                                the KlearNow app wants permission to access
                                certain types of data and will let you consent
                                (or not consent) to that request. Android
                                devices will notify you of the permissions that
                                the KlearNow app seeks before you first use the
                                app, and your use of the app constitutes your
                                consent.
                              </span>
                            </li>
                            <li>
                              <span
                                style={{
                                  fontFamily: '"Arial","sans-serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                After every Services and Delivery transaction,
                                Customers are able to rate Brokers and Truckers,
                                as well as give feedback on how the transaction
                                went that is then factored in calculating a
                                BrokerScore and a TruckerScore. Customer
                                Feedback is intended to provide accountability
                                and helps to improve the provision of services.
                              </span>
                            </li>
                          </ol>
                        </li>
                      </ul>
                      <div
                        style={{
                          margin: "0in",
                          marginBottom: ".0001pt",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                        }}
                      >
                        <ul
                          style={{ marginBottom: "0in", listStyleType: "disc" }}
                        >
                          <li
                            style={{
                              margin: "0in",
                              marginBottom: ".0001pt",
                              fontSize: 16,
                              fontFamily: '"Calibri","sans-serif"',
                            }}
                          >
                            <h6
                              style={{
                                marginTop: "2.0pt",
                                marginRight: "0in",
                                marginBottom: ".0001pt",
                                marginLeft: "0in",
                                fontSize: 16,
                                fontFamily: '"Calibri Light","sans-serif"',
                                color: "#1F3763",
                                fontWeight: "normal",
                                background: "white",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: '"inherit","serif"',
                                  fontSize: "13.5pt",
                                  color: "#003F5C",
                                }}
                              >
                                UPDATES TO THIS POLICY
                              </span>
                            </h6>
                          </li>
                        </ul>
                      </div>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.75in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          We may occasionally update this policy. If we make
                          significant changes, we will notify you of the changes
                          through the KlearNow.AI website or apps or through
                          others means, such as email. To the extent permitted
                          under applicable law, by using our services after such
                          notice, you consent to our updates to this policy.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "1.75in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".25in",
                          marginTop: "0in",
                          background: "white",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 18,
                            fontFamily: '"Arial","sans-serif"',
                            color: "#003F5C",
                          }}
                        >
                          We encourage you to periodically review this policy
                          for the latest information on our privacy practices.
                          We will also make prior versions of our privacy
                          policies available for review.
                        </span>
                      </p>
                      <p
                        style={{
                          marginRight: "0in",
                          marginLeft: "0in",
                          fontSize: 16,
                          fontFamily: '"Calibri","sans-serif"',
                          margin: "0in",
                          marginBottom: ".0001pt",
                        }}
                      >
                        &nbsp;
                      </p>
                    </>
                  </div>
                </Form.Field>
              </Form>
            </Segment>
          </div>
          <div
            className="footer-wrapper"
            style={{ color: "white", marginTop: "25px" }}
          >
            <p>
              <Link to="/" className="companyName">
                <strong>KlearNow Corp.</strong>
              </Link>
              &nbsp; &nbsp;| &nbsp; &nbsp;
              <Link
                to="/view-terms"
                style={{ color: "white", "margin-top": "25px" }}
              >
                Terms
              </Link>
              &nbsp; &nbsp; | &nbsp; &nbsp;
              <Link
                to="/privacy"
                style={{ color: "white", "margin-top": "25px" }}
              >
                Privacy
              </Link>
              &nbsp; &nbsp;
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default ViewPrivacy;
